import { ACCOUNT_DELETION_SESSION, isAccountDeletionPath } from '~/utils/accountDeletion'

export default defineNuxtRouteMiddleware((to) => {
  // Unload every cloud/save watcher when entering deletion, and start normal
  // gameplay plugins again only when the player explicitly leaves this page.
  if (import.meta.client && isAccountDeletionPath(to.path) !== ACCOUNT_DELETION_SESSION) {
    return navigateTo(to.fullPath, { external: true })
  }
})
